// Revenue & Profit Split vocabulary (PROMPT 14)
export { TONE, optOf, labelOf, toneOf, prettify } from "@/config/tone";

export const REVENUE_TYPES = [
  { value: "home_sale", label: "Home sale / wholesaling" },
  { value: "real_estate_referral", label: "Real estate referral" },
  { value: "senior_placement_referral", label: "Senior placement referral" },
  { value: "home_repair_project", label: "Home repair / accessibility" },
  { value: "downsizing_estate", label: "Downsizing / estate support" },
  { value: "auction_estate_sale", label: "Auction / estate sale" },
  { value: "moving_storage_referral", label: "Moving / storage referral" },
  { value: "consulting_fee", label: "Consulting fee" },
  { value: "franchise_branch_fee", label: "Franchise / branch fee" },
  { value: "partner_referral_fee", label: "Partner referral fee" },
  { value: "other", label: "Other" },
];

export const REVENUE_STATUSES = [
  { value: "identified", label: "Identified", tone: "gray" },
  { value: "estimated", label: "Estimated", tone: "sky" },
  { value: "proposal_sent", label: "Proposal sent", tone: "sky" },
  { value: "agreement_pending", label: "Agreement pending", tone: "amber" },
  { value: "active", label: "Active", tone: "navy" },
  { value: "closed_won", label: "Closed / won", tone: "green" },
  { value: "paid", label: "Paid", tone: "green" },
  { value: "split_distributed", label: "Split distributed", tone: "green" },
  { value: "closed_lost", label: "Closed / lost", tone: "red" },
];

export const SPLIT_RECIPIENT_ROLES = [
  { value: "mmm_corporate", label: "MovingMyMama Corporate" },
  { value: "branch", label: "Branch" },
  { value: "pastor_corey", label: "Pastor Corey" },
  { value: "brother_fred", label: "Brother Fred" },
  { value: "brother_steve", label: "Brother Steve" },
  { value: "consultant", label: "Consultant" },
  { value: "partner_vendor", label: "Partner / Vendor" },
  { value: "referral_source", label: "Referral source" },
  { value: "other", label: "Other team member" },
];

export const SPLIT_STATUSES = [
  { value: "pending", label: "Pending", tone: "gray" },
  { value: "owed", label: "Owed", tone: "amber" },
  { value: "paid", label: "Paid", tone: "green" },
];
